import { Gps } from 'app/generated/graphql';
import { MlEuiCommentType, buildEuiComment } from 'utils/configTranslator';

// AGPS Server Values - String field, no min/max needed
export const AGPS_SERVER_DEFAULT = 'supl.google.com:7276';

// Allow 2D Values - Boolean field, no min/max needed
export const ALLOW_2D_DEFAULT = false;

// SAT3 Timeout Value
export const SAT3_TIMEOUT_DEFAULT = 120; // seconds
export const SAT3_TIMEOUT_MIN = 30; // seconds
export const SAT3_TIMEOUT_MAX = 120; // seconds

// AGPS Comm Timeout Value
export const AGPS_COMM_TIMEOUT_DEFAULT = 30; // seconds
export const AGPS_COMM_TIMEOUT_MIN = 30; // seconds
export const AGPS_COMM_TIMEOUT_MAX = 120; // seconds

// Agps Data Retries Value
export const AGPS_DATA_RETRIES_DEFAULT = 1; // times
export const AGPS_DATA_RETRIES_MIN = 1; // times
export const AGPS_DATA_RETRIES_MAX = 10; // times

export const GPS_CONFIG_DEFAULTS: Gps = {
  agpsServer: AGPS_SERVER_DEFAULT,
  allow2d: ALLOW_2D_DEFAULT,
  sat3Timeout: SAT3_TIMEOUT_DEFAULT,
  agpsCommTimeout: AGPS_COMM_TIMEOUT_DEFAULT,
  agpsDataRetries: AGPS_DATA_RETRIES_DEFAULT,
};

export const GPS_GROUP_CONFIG_DEFAULTS: Gps = {
  // empty string is valid, this will set agps_server to not be used
  agpsServer: '',
  //@ts-expect-error form fields accept empty string for unset boolean fields
  allow2d: '',
  //@ts-expect-error form fields accept empty string for unset number fields
  sat3Timeout: '',
  //@ts-expect-error form fields accept empty string for unset number fields
  agpsCommTimeout: '',
  //@ts-expect-error form fields accept empty string for unset number fields
  agpsDataRetries: '',
};

// Builds items for an EUI comment list, in translated human readable format
export const gpsConfigTranslator = (gpsConfig: Gps | undefined | null) => {
  if (!gpsConfig) {
    return undefined;
  }
  const builtItems: Array<MlEuiCommentType> = [];

  if (gpsConfig.agpsServer) {
    builtItems.push(buildEuiComment('AGPS Server', gpsConfig.agpsServer));
  }
  if (typeof gpsConfig.allow2d === 'boolean') {
    builtItems.push(buildEuiComment('Allow 2D', gpsConfig.allow2d ? 'Enabled' : 'Disabled'));
  }
  if (gpsConfig.sat3Timeout) {
    builtItems.push(buildEuiComment('SAT3 Timeout', `${gpsConfig.sat3Timeout} seconds`));
  }
  if (gpsConfig.agpsCommTimeout) {
    builtItems.push(buildEuiComment('AGPS Comm Timeout', `${gpsConfig.agpsCommTimeout} seconds`));
  }
  if (gpsConfig.agpsDataRetries) {
    builtItems.push(buildEuiComment('AGPS Data Retries', `${gpsConfig.agpsDataRetries} times`));
  }

  return builtItems;
};
